module.exports = __webpack_public_path__ + "img/budget-1.a1f6c514.svg";